import { axiosInstance } from './base'

export const getPageLogo = async (serialNumber) => {
  const res = await axiosInstance({
    method: 'GET',
    url: `/pass/web_download_link_logo/${serialNumber}`
  })

  return res.request.responseURL
}

export const getPageDescription = async (serialNumber) => {
  const res = await axiosInstance({
    method: 'GET',
    url: `/pass/web_download_description/${serialNumber}`
  })

  return res.data
}

export const acceptTos = async (serialNumber, accepted = true) => {
  const res = await axiosInstance({
    method: 'GET',
    url: `/pass/web_ack_tos/${serialNumber}/${Number(accepted)}`
  })

  return res.data
}

export const getAppleLink = async (serialNumber) => {
  const res = await axiosInstance({
    method: 'GET',
    url: `/pass/web_download_link_apple/${serialNumber}`
  })

  return res.data
}

export const getGoogleLink = async (serialNumber) => {
  const res = await axiosInstance({
    method: 'GET',
    url: `/pass/web_download_link_google/${serialNumber}`
  })

  return res.data
}
